import * as React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableFooter from '@mui/material/TableFooter'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import InsertCommentIcon from '@mui/icons-material/InsertComment'
import LastPageIcon from '@mui/icons-material/LastPage'
import { useState } from 'react'
import { Stack } from '@mui/material'
import TableHead from '@mui/material/TableHead'
import '../../../App.css'
import '../../../css/modal.scss'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { useEffect } from 'react'
import { activeClass, focusElemnt } from '../../common/helper'
import moment from 'moment'
import { useAtom } from 'jotai'
import { companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { receiveLrListAtom, showListAllAtom } from '../../common/jotaiState/receiveStateAtoms'
import useToken from '../../helpers/useTokens'
import { RAJESH_TRANSPORT } from '../../../helper/companyIdhardcode'
export const ReceiveMiddleSection = ({  selelectedData, setSelectedData }) => {
  const [showListAll]=useAtom(showListAllAtom)
  const [receiveListData] = useAtom(receiveLrListAtom)
  const [companySettings] = useAtom(companySettingsAtom)
  const { loginData } = useToken()
  const { DefaultCurrencyID } = companySettings

  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(8)

  // All State
  const [state, setState] = useState({
    // ListData:[],
    startIndex: 0,
    lastIndex: 8,
    Total: 0,
    TotalAmount: 0,
  })
  const { startIndex, lastIndex, Total, TotalAmount } = state
  const [ListData, setListData] = useState()
  const [TableListData, setTableListData] = useState('DataLoaded')
  const [filtered, setFiltered] = useState([])
  const [searchStatus, setSearchStatus] = useState(false)

  // All useEffects
  useEffect(() => {
    if (receiveListData?.length >= 1) {
      const arry = receiveListData?.map((val) => ({
        ...val,
        // checked: false,
        DescriptionDet: val.ConsignmentData?.[0].ConsignmentSubType,
        BookingDateTime: moment(val.BookingDateTime).format('DD MMM YYYY  LT'),
      }))
      setTableListData('DataLoaded')
      setListData(arry)
      setTimeout(() => {
        focusElemnt('checkbox_0')
      }, 0)
    } else {
      setListData([])
      setTableListData('Empty')
    }
  }, [receiveListData])
  // useEffect(() => {
  //   if (showListAll) {
  //     if (selelectedData?.length === 0) {
  //       const arry = receiveListData?.map((val) => ({ ...val, checked: true }))
  //       setListData(arry)
  //       setSelectedData(receiveListData)

  //     } else {
  //       const selBookId = selelectedData.map(({ BookingID }) => BookingID)
  //       let filterLR = receiveListData.filter((item) => selBookId.includes(item.BookingID))
  //       setSelectedData(filterLR)
  //     }
  //   } else {
  //     setSelectedData([])
  //   }
  // }, [receiveListData, showListAll])
  useEffect(() => {
  if (!receiveListData) return

  if (showListAll) {
    setSelectedData(receiveListData)
  } else {
    setSelectedData([])
  }
}, [showListAll, receiveListData])

  useEffect(() => {
    const citrus = receiveListData?.slice(startIndex, lastIndex)
    const total = citrus?.map((item) => item?.Quantity).reduce((partialSum, a) => partialSum + a, 0)
    const totalAmt = citrus?.map((item) => item?.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
    setState({ ...state, Total: total, TotalAmount: totalAmt?.toFixed(2) })
  }, [startIndex, lastIndex, receiveListData])

  // const onChange = (e, i, BookingIDItem) => {
  //   const { checked, value, id } = e.target
  //   if (checked) {
  //     // (searchStatus ? filtered : ListData)?.map((val) => (val.BookingID === Number(id) ? (val.checked = true) : ''))
  //     ListData?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = true) : ''))
  //     filtered?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = true) : ''))
  //     const data = (searchStatus ? filtered : ListData)?.filter((val) => val.BookingID == Number(BookingIDItem))
  //     const selectedObject = [...selelectedData, data[0]]
  //     setSelectedData(selectedObject)
  //   } else {
  //     // (searchStatus ? filtered : ListData)?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = false) : ''))
  //     ListData?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = false) : ''))
  //     filtered?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = false) : ''))
  //     const data = selelectedData.filter((item) => item.BookingID !== Number(BookingIDItem))
  //     setSelectedData(data)
  //   }
  //   setTimeout(() => {
  //     focusElemnt(`checkbox_${i}`)
  //   }, 3)
  // }
  const onChange = (e, i, BookingIDItem) => {
  const isChecked = e.target.checked

  if (isChecked) {
    const selectedItem = receiveListData.find(x => x.BookingID === BookingIDItem)
    setSelectedData(prev => [...prev, selectedItem])
  } else {
    setSelectedData(prev => prev.filter(x => x.BookingID !== BookingIDItem))
  }

  setTimeout(() => focusElemnt(`checkbox_${i}`), 3)
}

  const addRemoveKeydown = (e, i) => {
    if (e.key === 'ArrowDown') {
      focusElemnt(`checkbox_${i + 1}`)
    }
    if (e.key === 'ArrowUp') {
      focusElemnt(`checkbox_${i - 1}`)
    }
    if (e.key === 'Enter') {
      focusElemnt('receiveRemarks')
    }
    if (e.key === 'Escape') {
      focusElemnt('receiveShowList')
    }
  }
  const InsideRowContent = ({ item, index }) => {
    const [show, setShow] = useState(false)
    //this function for  total
    const handleCalculation = (list, name) => {
      let total = 0
      for (let i in list) {
        total = total + Number(list[i][name])
      }
      return total.toLocaleString('en-IN')
    }

    const handleTotalCalculation = (list) => {
      let frieght = list.ConsignmentData.map((item) => item?.Freight).reduce((partialSum, a) => partialSum + a, 0)
      let total = frieght + list.AllCartage + list.AllHamali + list.OtherCharge + list.Valuation + list.GST
      return total.toLocaleString('en-IN')
    }
    const isRajesh = loginData?.intCompanyID === RAJESH_TRANSPORT

    return (
      <>
        <TableBody className="filter-data-row" key={index}>
          <TableRow>
            <TableCell className="checkbox-ctrl">
              {/* <input
                type="checkbox"
                id={`checkbox_${index}`}
                // value={item}
                onChange={(e) => onChange(e, index, item.BookingID)}
                checked={item.checked}
                onKeyDown={(e) => addRemoveKeydown(e, index)}
                // name="record"
              /> */}
              <input
                type="checkbox"
                id={`checkbox_${index}`}
                onChange={(e) => onChange(e, index, item.BookingID)}
                checked={selelectedData?.some(x => x.BookingID === item.BookingID)}
                onKeyDown={(e) => addRemoveKeydown(e, index)}
              />
            </TableCell>
            <TableCell>
              {item.LRNO}
            </TableCell>
            {!isRajesh && (
              <TableCell>
                <span style={{ fontSize: '13px' }} title={item.ManualLRNo}>
                  {item.ManualLRNo}
                </span>
              </TableCell>
            )}
            <TableCell>
              <span style={{ fontSize: '13px' }} title={item.BookingDateTime}>
                {item.BookingDateTime}
              </span>
            </TableCell>
            <TableCell>
              <span style={{ fontSize: '13px' }} title={item.DescriptionDet}>
                {item.ConsignmentData.length === 1 ? item.DescriptionDet : 'Multi'}
              </span>
            </TableCell>
            <TableCell>
              <span className={activeClass(item.PaymentType)} title={item.PaymentType}>
                {item.PaymentType}
              </span>
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <span style={{ fontSize: '13px', paddingRight: '30px' }} title={item.Quantity}>
                {item.Quantity}
              </span>
            </TableCell>
            {!isRajesh && (
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.Sender}>
              {item.Sender}
            </span>
          </TableCell>
        )}
            {!isRajesh && (
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.RecName}>
              {item.RecName}
            </span>
          </TableCell>
        )}
            <TableCell>
              <span style={{ fontSize: '13px' ,textAlign: 'left'}} title={item.FromCity}>
                {item.FromCity}
              </span>
            </TableCell>
            <TableCell>
              <span style={{ fontSize: '13px' }} title={item.ToCity}>
                {item.ToCity}
              </span>
            </TableCell>
           {!isRajesh && (
          <TableCell style={{ textAlign: 'right' }}>
            <span style={{ fontSize: '13px', paddingRight: '29px' }} title={item.NetAmount}>
              {Number(item.NetAmount).toLocaleString('en-IN')}
            </span>
          </TableCell>
        )}
            <TableCell style={{ textAlign: 'right' }}>
              <span style={{ fontSize: '13px', paddingRight: '29px' }} title={item.ChallanNo}>
                {/* {item.NetAmount} */}
                {Number(item.ChallanNo).toLocaleString('en-IN')}
              </span>
            </TableCell>
            <TableCell className="iconCell" style={{ textAlign: 'right', display: 'flex', justifyContent: 'right', alignItems: 'end' }}>
              {item.Comments === '' ? (
                ''
              ) : (
                <span title={item.Comments}>
                  <InsertCommentIcon id="iconBox" className="icon2" style={{ marginRight: '13px' }} />
                </span>
              )}
              {!isRajesh && (
                <span onClick={() => setShow(!show)}>
                  {show ? (
                    <RemoveCircleIcon id="iconBox" className="icon2" style={{ marginRight: '12px' }} />
                  ) : (
                    <AddCircleIcon id="iconBox" className="icon2" style={{ marginRight: '12px' }} />
                  )}
                </span>
              )}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={14} style={{ padding: '0' }}>
              <div
                className="tabelAccordionWrapper"
                style={{
                  maxHeight: '110px',
                  overflowY: 'scroll',
                }}
              >
                <Table className="table1 table-branch sub-table" size="small" aria-label="a dense table">
                  <TableBody className="filter-data-row">
                    {show && (
                      <>
                        <TableRow key={index} style={{ background: '#E5D6CF' }}>
                          <TableCell className="checkbox-ctrl" style={{ background: '#E5D6CF' }}></TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold' }} title={'ConsignmentSubType'}>
                              Consign Type
                            </span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold' }}>Description</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Unit</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Goods Value</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Weight</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Rate</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Frieght</span>
                          </TableCell>

                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Cartage</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Hamali</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Other</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>{DefaultCurrencyID === 2 ? 'Insurance' : 'Valuation'}</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>GST</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Total</span>
                          </TableCell>
                        </TableRow>

                        {item.ConsignmentData.map((val, i) => {
                          return (
                            <TableRow key={i + 'wws'} style={{ background: '#FBEDE7' }}>
                              <TableCell className="checkbox-ctrl" style={{ background: '#FBEDE7' }}></TableCell>
                              <TableCell>
                                <span style={{ fontSize: '10px' }} title={val.ConsignmentSubType}>
                                  {val.ConsignmentSubType}
                                </span>
                              </TableCell>
                              <TableCell>
                                <span style={{ fontSize: '10px' }} title={val.Description}>
                                  {val.Description}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.Quantity}>
                                  {val.Quantity}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.GoodsValue}>
                                  {val.GoodsValue}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.ActualWeight}>
                                  {val.ActualWeight}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.Rate}>
                                  {val.Rate}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.Freight}>
                                  {/* {val.Freight} */}
                                  {Number(val.Freight).toLocaleString('en-IN')}
                                </span>
                              </TableCell>

                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.AllCartage}>
                                  {/* {item.AllCartage} */}
                                  {item.ConsignmentData.length > 1 ? 0 : item.AllCartage}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.AllHamali}>
                                  {/* {item.AllHamali} */}
                                  {item.ConsignmentData.length > 1 ? 0 : item.AllHamali}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.OtherCharge}>
                                  {item.ConsignmentData.length > 1 ? 0 : item.OtherCharge}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.Valuation}>
                                  {/* {item.Valuation} */}
                                  {item.ConsignmentData.length > 1 ? 0 : item.Valuation}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={Number(item.GST).toLocaleString('en-IN')}>
                                  {/* {Number(item.GST).toLocaleString("en-IN")} */}
                                  {item.ConsignmentData.length > 1 ? 0 : Number(item.GST).toLocaleString('en-IN')}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.Valuation}>
                                  {item.ConsignmentData.length > 1 ? 0 : handleTotalCalculation(item)}
                                </span>
                              </TableCell>
                            </TableRow>
                          )
                        })}
                        {item.ConsignmentData.length > 1 ? (
                          <TableRow style={{ background: '#e9d5cf' }}>
                            <TableCell className="checkbox-ctrl" style={{ background: '#e9d5cf' }}></TableCell>
                            <TableCell>
                              <span style={{ fontSize: '12px', fontWeight: 'bold' }}>Grand Total</span>
                            </TableCell>
                            <TableCell>
                              <span style={{ fontSize: '10px', fontWeight: 'bold' }}></span>
                            </TableCell>
                            <TableCell style={{ textAlign: 'right' }}>
                              <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                {handleCalculation(item.ConsignmentData, 'Quantity')}
                              </span>
                            </TableCell>
                            <TableCell style={{ textAlign: 'right' }}>
                              <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                {handleCalculation(item.ConsignmentData, 'GoodsValue')}
                              </span>
                            </TableCell>
                            <TableCell style={{ textAlign: 'right' }}>
                              <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                {handleCalculation(item.ConsignmentData, 'ActualWeight')}
                              </span>
                            </TableCell>
                            <TableCell style={{ textAlign: 'right' }}>
                              <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                {handleCalculation(item.ConsignmentData, 'Rate')}
                              </span>
                            </TableCell>
                            <TableCell style={{ textAlign: 'right' }}>
                              <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                {handleCalculation(item.ConsignmentData, 'Freight')}
                              </span>
                            </TableCell>

                            <TableCell>
                              <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.AllCartage}</span>
                            </TableCell>
                            <TableCell>
                              <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.AllHamali}</span>
                            </TableCell>
                            <TableCell>
                              <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.OtherCharge}</span>
                            </TableCell>
                            <TableCell>
                              <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.Valuation}</span>
                            </TableCell>
                            <TableCell>
                              <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>
                                {Number(item.GST).toLocaleString('en-IN')}
                              </span>
                            </TableCell>
                            <TableCell style={{ textAlign: 'right' }}>
                              <span style={{ fontSize: '10px', fontWeight: 'bold' }}>{handleTotalCalculation(item)}</span>
                            </TableCell>
                          </TableRow>
                        ) : (
                          ''
                        )}
                      </>
                    )}
                  </TableBody>
                </Table>
              </div>
            </TableCell>
          </TableRow>
        </TableBody>
      </>
    )
  }

  //All Functionality of pagination  start
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  function TablePaginationActions(props) {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props
    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0)
      setState({ ...state, startIndex: 0, lastIndex: 8 })
    }

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1)
      setState({ ...state, startIndex: startIndex - 8, lastIndex: startIndex })
    }

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1)
      if (receiveListData.length >= lastIndex + 8) {
        setState({ ...state, startIndex: lastIndex, lastIndex: lastIndex + 8 })
      } else {
        setState({ ...state, startIndex: lastIndex, lastIndex: receiveListData?.length + 1 })
      }
    }

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
      const div = receiveListData?.length % 8
      if (div == 0) {
        const index = receiveListData?.length - 8
        setState({ ...state, startIndex: index, lastIndex: receiveListData?.length + 1 })
      } else {
        const index = receiveListData?.length - (receiveListData?.length % 8)
        setState({ ...state, startIndex: index, lastIndex: receiveListData?.length + 1 })
      }
    }

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
          style={{ padding: '0px', margin: '0px' }}
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          style={{ padding: '0px', margin: '0px' }}
          aria-label="previous page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          style={{ padding: '0px', margin: '0px' }}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          style={{ padding: '0px', margin: '0px' }}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    )
  }

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  }
  //All Functionality of pagination end

  let repeatdata = [
    { id: 0, name: 'contains', colName: 'LRNO' },
    { id: 1, name: 'contains', colName: 'ManualLRNo' },
    { id: 2, name: 'contains', colName: 'BookingDateTime' },
    { id: 3, name: 'contains', colName: 'DescriptionDet' },
    { id: 4, name: 'contains', colName: 'PaymentType' },
    { id: 5, name: 'contains', colName: 'Quantity' },
    { id: 6, name: 'contains', colName: 'Sender' },
    { id: 7, name: 'contains', colName: 'RecName' },
    { id: 8, name: 'contains', colName: 'FromCity' },
    { id: 9, name: 'contains', colName: 'ToCity' },
    { id: 10, name: 'contains', colName: 'NetAmount' },
    { id: 11, name: 'contains', colName: 'ChallanNo' },
  ]
  const handleChangeContain = (id, name) => {
    // console.log(id, name)
    var userInput = document.getElementsByName('searchInput')[id].value
    var count = 0
    const lData = []
    const data = ListData
    // console.log(data)
    if (userInput !== '') {
      var regex = new RegExp(userInput.trim().replace(/\\/g, "\\\\"), 'i')
      {
        data.map((val) => {
          if ((val[name] != null ? val[name].toString() : '').search(regex) !== -1) {
            const x = {
              ActualWeight: val.ActualWeight,
              AllCartage: val.AllCartage,
              AllHamali: val.AllHamali,
              AutoUserID: val.AutoUserID,
              BookingCitySC: val.BookingCitySC,
              BookingDateTime: val.BookingDateTime,
              BookingID: val.BookingID,
              ChallanNo: val.ChallanNo,
              ConsignmentData: val.ConsignmentData,
              DamageQty: val.DamageQty,
              Description: val.Description,
              DescriptionDet: val.DescriptionDet,
              DestinationBranchID: val.DestinationBranchID,
              DestinationBranchName: val.DestinationBranchName,
              DestinationCitySC: val.DestinationCitySC,
              DispatchDateTime: val.DispatchDateTime,
              DispatchDetID: val.DispatchDetID,
              DispatchFromCitySC: val.DispatchFromCitySC,
              DispatchID: val.DispatchID,
              DispatchToCitySC: val.DispatchToCitySC,
              Freight: val.Freight,
              FromBranchID: val.FromBranchID,
              FromCity: val.FromCity,
              FromCityID: val.FromCityID,
              GST: val.GST,
              GoodsValue: val.GoodsValue,
              LRNO: val.LRNO,
              ManualLRNo: val.ManualLRNo,
              NetAmount: val.NetAmount,
              OtherCharge: val.OtherCharge,
              PARCEL: val.PARCEL,
              PaymentType: val.PaymentType,
              Quantity: val.Quantity,
              Rate: val.Rate,
              RecAddress: val.RecAddress,
              RecMobileNo: val.RecMobileNo,
              RecName: val.RecName,
              ReceiverEmailID: val.ReceiverEmailID,
              ReceiverGSTN: val.ReceiverGSTN,
              Remarks: val.Remarks,
              Sender: val.Sender,
              SenderAddress: val.SenderAddress,
              SenderEmailID: val.SenderEmailID,
              SenderGSTN: val.SenderGSTN,
              SenderMobileNo: val.SenderMobileNo,
              ShortQty: val.ShortQty,
              SubType: val.SubType,
              ToBranchID: val.ToBranchID,
              ToCity: val.ToCity,
              ToCityID: val.ToCityID,
              Valuation: val.Valuation,
              VehicleNo: val.VehicleNo,
              checked: val.checked,
            }
            lData.push(x)
            count++
          }
        })
      }
      setFiltered(lData)
      setSearchStatus(true)
    } else {
      setFiltered([])
      setSearchStatus(false)
    }
  }
  const tableHeaders = [
    { label: 'Select', style: { fontSize: '13px', padding: '10px 0px 10px 25px', fontWeight: 'bold', textAlign: 'center', } },
    { label: 'LR/Way Bill No.', style: { fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'left', } },
    { label: 'Manual LR', style: { fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'left', } },
    { label: 'Booking Date', style: { fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'left', } },
    { label: 'Consign Type', style: { fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'left', } },
    { label: 'Payment Type', style: { fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'left', } },
    { label: 'Units', className: 'receiveTableTd', textAlign: 'center' },
    { label: 'Sender', style: { fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'left', } },
    { label: 'Receiver', style: { fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'left', } },
    { label: 'Source', style: { fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'left', } },
    { label: 'Destination', style: { fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'left', } },
    {
      label: 'Amount',
      style: { fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'right', paddingRight: '32px' },
    },
    {
      label: 'Challan',
      style: { fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'right', paddingRight: '32px' },
    },
    {
      label: 'Activity',
      style: { fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'center', paddingRight: '30px' },
    },
  ]
  const hiddenForRajesh = ['Manual LR', 'Sender', 'Receiver', 'Amount']
  const isRajesh = loginData?.intCompanyID === RAJESH_TRANSPORT

  const finalHeaders = isRajesh ? tableHeaders.filter(h => !hiddenForRajesh.includes(h.label)) : tableHeaders
  const finalRepeatData = isRajesh ? repeatdata.filter(item => !['ManualLRNo', 'Sender', 'RecName', 'NetAmount'].includes(item.colName)) : repeatdata

  return (
    <>
      <Stack sx={{ maxHeight: 360, minHeight: 360, minWidth: 650, margin: 2, marginRight: 3, marginLeft: 3 }}>
        <TableContainer className="lr-popup-table lrModel " component={Paper}>
          <Table style={{}} className="table1 tableV2-branch receiveTable" size="small" aria-label="a dense table" id="showlisttable">
            <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
              <TableRow style={{ background: '#d9edff' }}>
                {finalHeaders.map((item, index) => (
                  <TableCell key={item.key || index} style={item.style} className={item.className}>
                    {item.label}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell className="checkbox-ctrl"></TableCell>
                {finalRepeatData.map((item, i) => (
                  <TableCell key={i + '24q'}>
                    <div className={`filter-input ${i === finalRepeatData.length - 1 ? 'last-filter' : ''}`}>
                      <input
                        className="field"
                        name="searchInput"
                        placeholder={item.name}
                        onChange={() => handleChangeContain(item.id, item.colName)}
                        style={{ width: '75px' }}
                      />
                      <FilterAltIcon />
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {TableListData === 'Empty' ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '14px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : TableListData === 'DataLoaded' ? (
              <>
                {(rowsPerPage > 0
                  ? (searchStatus ? filtered : ListData)?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : searchStatus
                  ? filtered
                  : ListData
                )?.map((item, index) => (
                  <InsideRowContent item={item} index={index} />
                ))}
              </>
            ) : (
              ''
            )}
            <TableFooter>
              <TableRow>
                <TableCell colSpan={isRajesh?4:5} style={{ fontSize: '13px', fontWeight: 'bold' }}></TableCell>
                <TableCell style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right', paddingRight: '7px' }}>Total</TableCell>
                <TableCell style={{ fontSize: '9px', fontWeight: 'bold', textAlign: 'center', paddingRight: '49px' }}>
                  {Total === undefined ? '' : Number(Total).toLocaleString('en-IN')}
                </TableCell>
                <TableCell colSpan={3} style={{ fontSize: '13px', fontWeight: 'bold' }}></TableCell>
                {!isRajesh && <TableCell colSpan={2} style={{ fontSize: '9px', fontWeight: 'bold', textAlign: 'right', paddingRight: '30px' }}>
                  {TotalAmount === undefined ? '' : Number(TotalAmount).toLocaleString('en-IN')}
                </TableCell>}
                <TableCell colSpan={2}></TableCell>
              </TableRow>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                  // colSpan={3}
                  count={receiveListData?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  className="test123"
                  SelectProps={{
                    inputProps: {
                      'aria-label': 'rows per page',
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Stack>
    </>
  )
}
